import { X } from 'lucide-react'
import { useState } from 'react'

import { Badge } from 'components/ui/badge'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'

type TextCollectionProps = {
  placeholder?: string
  value: string[]
  onAddItem: (value: string) => void
  onRemoveItem: (value: string) => void
}

const TextCollection = ({
  placeholder,
  value,
  onAddItem,
  onRemoveItem,
}: TextCollectionProps) => {
  const [inputValue, setInputValue] = useState('')

  const handleAdd = () => {
    const trimmedValue = inputValue.trim()
    if (trimmedValue) {
      onAddItem(trimmedValue)
      setInputValue('')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    }
  }

  return (
    <div className='space-y-2'>
      <div className='flex gap-2'>
        <Input
          type='text'
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className='flex-1'
        />
        <Button
          type='button'
          onClick={handleAdd}
          disabled={!inputValue.trim()}
          variant='secondary'
        >
          Add
        </Button>
      </div>

      {value.length > 0 && (
        <div className='flex flex-wrap gap-2'>
          {value.map((item) => (
            <Badge
              key={item}
              variant='secondary'
              className='flex items-center gap-1 pr-1 font-medium'
            >
              <span>{item}</span>
              <button
                type='button'
                onClick={() => onRemoveItem(item)}
                className='ml-1 rounded-full hover:bg-gray-300 p-0.5'
                aria-label={`Remove ${item}`}
              >
                <X className='h-3 w-3' />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  )
}

export default TextCollection
